import APIService from './APIService';

export default {
  getCargas() {
    return new Promise((resolve, reject) => {
      APIService.apiCall()
        .get('cargas-arquivos-dados-geograficos/get-cargas')
        .then((response) => {
          const { data: cargas } = response.data;
          resolve(cargas);
        })
        .catch((error) => reject(error));
    });
  },
  save(data) {
    return new Promise((resolve, reject) => {
      APIService.apiCall()
        .post('cargas-arquivos-dados-geograficos/salvar', JSON.stringify(data))
        .then(() => resolve(true))
        .catch(() => reject(false));
    });
  },
  getAllowedFiles() {
    return APIService.apiCall().get('cargas-arquivos-dados-geograficos/arquivos-permitidos');
  },
  getDadosTabelaDestino(arquivoId, extensaoSugerida = null) {
    const params = extensaoSugerida ? `?extensao_sugerida=${extensaoSugerida}` : '';
    return APIService.apiCall().get(`cargas-arquivos-dados-geograficos/get-dados-tabela-destino/${arquivoId}${params}`);
  },
  baixarZip(id, config = {}) {
    return APIService.apiCall().get(`/cargas-arquivos-dados-geograficos/download-arquivo-zip-logs/${id}`, {
      responseType: 'blob',
      ...config
    });
  }
};
